import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication.service';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    auditorRoles: string[] = ['admin_auditor', 'user_auditor'];
    currentUser: any;

    constructor(
        private _http: HttpClient,
        private _authenticationService: AuthenticationService
    ) {
        this._authenticationService.currentUser.subscribe(user => {
            this.currentUser = user;
        });
    }

    getUserLocationData(): Observable<any> {
        return this._http.get(`${environment.apiUrl}app/location-from-ip`);
    }

    getAuditorRoles(): string[] {
        return this.auditorRoles;
    }

    /**
     * Service to import CSV, XLSX data by file/copy-paste 
     */
    importMultiFormatData(method: string, modelName: string, mapping: any, file: File | null, csvData: any | null): Observable<any> {
        const formData: any = new FormData();
        formData.append('user', this.currentUser._id)
        formData.append('modelName', modelName);
        formData.append('headersMap', JSON.stringify(mapping));
        formData.append('method', method);
        if (method === 'file') {
            formData.append('file', file);
        } else if (method === 'copy-paste') {
            formData.append('csvData', JSON.stringify(csvData));
        }

        return this._http.post(`${environment.yiiUrl}import/multi-format-importer`, formData);
    }

    /**
     * Import CSV file via background process
     * @param formData 
     * @returns 
     */
    importCSV(formData: FormData): Observable<any> {
        return this._http.post(`${environment.yiiUrl}common/import-csv`, formData);
    }

    /**
     * Donwload CSV file via background process
     * @param filter 
     * @returns 
     */
    downloadCSV(filter: any): Observable<any> {
        return this._http.post(`${environment.yiiUrl}common/download-csv`, filter);
    }
}